import React from "react";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";
import { toast } from "react-toastify";
import { CheckboxIcon, StyledH2, StyledModal } from "@aureskonnect/react-ui";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import {
    customColumnProps,
    DynamicTable,
} from "@maherunlocker/custom-react-table";
import ErrorToast from "@components/Common/ErrorTost";

import { store } from "@components/VerticalLayout/store";
import {
    store as generalSettingStore,
    setIsAssociateModalOpened,
    setIsAssociateModalClosed,
    setNumberActiveMultiShop,
    setIsAssociatedModeOfInformation,
    setSelectedRow,
    setMessage,
    setIsLoading,
    setKey,
} from "../store";

import { CustomIconsAssociateModal } from "./CustomIconsAssociateModal";
import CustomColumnDisplay from "@components/Common/CustomColumnDisplay";
import { useFetchGlobal } from "../../../../api/hooks";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";

import "@assets/swal.css";
import "@assets/theme.css";
import "react-toastify/dist/ReactToastify.css";
import { setItemsDisable } from "@store";
import { useAuthHeader } from "../../../../api/headersKeycloak";
import {
    checkIfModeOfInformationExistAndArchived,
    CountIds,
    groupByShopId,
} from "../helper";
import { uuid } from "uuidv4";

export function ModeOfInformationAssociateModal({
    setData,
    isModeOfInformationArchived,
    setIsModeOfInformationArchived,
    rowData,
}: any) {
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();
    const getAuthHeader = useAuthHeader();

    const {
        isAssociateModalOpened,
        localShop,
        isAssociateModalClosed,
        numberActiveMultiShop,
        idsLocalShop,
        associatedModeInformation,
        activeModeInformation,
        rowsShop,
    } = useSnapshot(generalSettingStore);
    const { userID, franchiseID, operatorID } = useSnapshot(store);
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const uuidUser = localStorage.getItem("uuidUser");
    const [selectedRows, setSelectedRows] = React.useState<any[]>([]);
    const [dataIsUpdated, setDataIsUpdated] = React.useState<boolean | number>(
        false
    );
    const [modifiedRows, setModifiedRows] = React.useState<any[]>([]);

    const shopId = 0;
    const url = `${
        process.env.REACT_APP_API_V2_URL
    }/settings/general/mode_of_Information?userId=${userID}&shopId=${shopId}&franchiseId=${franchiseID}${
        localShop.length === 1 ? `&prefix=${localShop[0]}` : ""
    }`;

    const ActionColumn = (e: any) => {
        return e.selectedRow.subRows === undefined ? <div></div> : null;
    };

    let arrayOfCustomColumns: customColumnProps[] = [
        {
            indexOFColumn: 1,
            columnName: t("Mode of information"),
            customJsx: (e: any) => <NumberModeOfInformation e={e} />,
            filterName: t("Mode of information"),
            canFilter: true,
        },
        {
            indexOFColumn: 2,
            columnName: t("Sales method"),
            customJsx: (e: any) => (
                <CustomColumnDisplay
                    text={
                        Array.isArray(e.selectedRow[t("Sales method")])
                            ? e.selectedRow[t("Sales method")]
                                  .map((x: any) => {
                                      return x.label;
                                  })
                                  .join(",")
                            : e.selectedRow[t("Sales method")]
                    }
                />
            ),
            filterName: t("Sales method"),
            canFilter: true,
        },
        {
            indexOFColumn: 3,
            columnName: t("Support of sale"),
            customJsx: (e: any) => (
                <CustomColumnDisplay
                    text={
                        e.selectedRow[t("Sales support")] !== undefined &&
                        Object.keys(e.selectedRow[t("Sales support")]).length >
                            0
                            ? e.selectedRow[t("Sales support")]?.label
                            : ""
                    }
                />
            ),
            filterName: t("Support of sale"),
            canFilter: true,
        },
        {
            indexOFColumn: 4,
            columnName: t("Tag"),
            customJsx: (e: any) => (
                <CustomColumnDisplay
                    text={
                        Array.isArray(e.selectedRow.tag)
                            ? e.selectedRow.tag.join(",")
                            : ""
                    }
                />
            ),
            filterName: t("Tag"),
            canFilter: true,
        },
        {
            indexOFColumn: 5,
            columnName: t("Actions"),
            customJsx: (e: any) => (
                <CustomIconsAssociateModal
                    e={e}
                    setDataIsUpdated={setDataIsUpdated}
                    modifiedRows={modifiedRows}
                    setModifiedRows={setModifiedRows}
                    isModeOfInformationArchived={isModeOfInformationArchived}
                    setIsModeOfInformationArchived={
                        setIsModeOfInformationArchived
                    }
                />
            ),
            filterName: t("Actions"),
            canFilter: true,
        },
    ];

    function NumberModeOfInformation(e: any) {
        return (
            <React.Fragment>
                {e.e.selectedRow?.subRows !== undefined ? (
                    <h6 className="badge__clz">
                        {e.e.selectedRow[t("Shop")] !== ""
                            ? e.e.selectedRow.subRows?.length
                            : 0}
                    </h6>
                ) : (
                    e.e.selectedRow[t("Mode of information")]
                )}
            </React.Fragment>
        );
    }

    async function AssociateModeOfInformation() {
        setIsLoading(true);
        toast.dismiss();
        let localData: any = [];
        let successCount = 0;

        for (let elx of rowData) {
            let objectData: any = {};
            let element = elx.shopId;

            if (selectedRows.length !== 0) {
                selectedRows.forEach((el: any) => {
                    if (el.Id !== undefined) {
                        Object.assign(objectData, {
                            [el.Id]: {
                                designation: el[t("Mode of information")],
                                idMI: el?.idMI,
                                supportOfSale: el[t("Sales support")],
                                salesSupportData: [el[t("Sales support")]],
                                displayName: el[t("Display name")],
                                modeOfSale: el[t("Sales method")],
                                tag: el.tag,
                                isArchived: el.isArchived,
                                shopId: [element],
                                state: activeModeInformation.find(
                                    (element: any) => element.Id === el.Id
                                ).state,
                                advancedDisplayName: el.advancedDisplayName,
                            },
                        });
                    }
                });

                // Only add to localData if objectData is not empty
                if (Object.keys(objectData).length > 0) {
                    let dataModeOfInformation = {
                        userId: userID,
                        operatorId: operatorID,
                        uuidUser: uuidUser,
                        shopId: [element],
                        franchiseId: franchiseID,
                        data: objectData,
                        isAssociate: true,
                        isShop: true,
                    };
                    localData.push(dataModeOfInformation);
                    successCount += Object.keys(objectData).length;
                }
            }
        }

        // Only send POST request if there is data to send
        if (localData.length > 0) {
            localData = groupByShopId(localData);

            try {
                const response: any = await fetchGlobal(
                    `${process.env.REACT_APP_API_V2_URL}/settings/general/mode_of_Information`,
                    {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(localData),
                    }
                );

                if (response.error === false) {
                    const itemsDisable: any = await fetchGlobal(
                        `${process.env.REACT_APP_API_V2_URL}/settings/consomation/items?franchiseId=${franchiseID}&shopId=0`,
                        {
                            method: "GET",
                            headers: { "Content-Type": "application/json" },
                        }
                    );
                    if (itemsDisable.error === false) {
                        setItemsDisable(itemsDisable.data);
                    }
                    toast.success(
                        `${t("Information mode assignment was successful")!}`,
                        {
                            position: toast.POSITION.TOP_CENTER,
                            theme: "colored",
                            icon: (
                                <CheckboxIcon
                                    height={25}
                                    width={25}
                                    fill="white"
                                />
                            ),
                        }
                    );
                    setKey(uuid());
                    setNumberActiveMultiShop(
                        numberActiveMultiShop + successCount
                    );
                }
                if (response.blockAssign === true) {
                    toast.warn(
                        t(
                            "Please note that the assignment could not be made to one or more stores. Please check the store(s) data settings."
                        ),
                        {
                            position: toast.POSITION.TOP_CENTER,
                            autoClose: 2000,
                            theme: "colored",
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                        }
                    );
                }
            } catch (e) {
                toast.error(`${t("There's an error")!}`, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                    theme: "colored",
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            } finally {
                setIsLoading(false);
            }
        } else {
            // No data to send - all rows were filtered out
            setIsLoading(false);
            toast.warn(
                t(
                    "Please note that the assignment could not be made to one or more stores. Please check the store(s) data settings."
                ),
                {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                    theme: "colored",
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                }
            );
        }
    }

    function validateSelectedRows(
        archived: any[]
    ): {
        isValid: boolean;
        message?: string;
    } {
        const associatedMap = new Map(
            associatedModeInformation.map((item: any) => [item.Id, item])
        );
        const activeMap = new Map(
            activeModeInformation.map((item: any) => [item.Id, item])
        );
        for (const el of selectedRows) {
            const associated = associatedMap.get(el.Id);
            const active = activeMap.get(el.Id);
            if (associated && active && associated.state !== active.state) {
                return {
                    isValid: false,
                    message: t(
                        "Warning! This change will affect specific settings in the store(s).\n\nDo you want to confirm the modification?"
                    ),
                };
            }
        }
        for (const el of selectedRows) {
            if (archived.includes(el.Id)) {
                return {
                    isValid: false,
                    message: t(
                        "Attention! One or more selected mode of information are already assigned and archived at the store level.Would you unarchive them?"
                    ),
                };
            }
        }

        return { isValid: true };
    }

    function handleValidateClick() {
        const archived = checkIfModeOfInformationExistAndArchived(rowsShop);
        CountIds(idsLocalShop, selectedRows);
        if (selectedRows.length === 0) {
            ErrorToast(
                t(
                    "Attention ! You must select at least one mode of information"
                )
            );
            return;
        }
        setSelectedRow(selectedRows);
        const validation = validateSelectedRows(archived);
        if (!validation.isValid) {
            setMessage(validation.message!);
            setIsAssociatedModeOfInformation(true);
            return;
        }
        AssociateModeOfInformation();
        setIsAssociateModalOpened(!isAssociateModalOpened);
    }

    return (
        <StyledModal
            toggle={true}
            isOpen={isAssociateModalOpened!}
            centered
            className="modal-wrapper__clz"
            backdrop="static"
            fade={false}
            scrollable
        >
            <ModalHeader
                className="text-capitalize"
                toggle={() => {
                    setIsAssociateModalOpened(!isAssociateModalOpened);
                    setIsAssociateModalClosed(!isAssociateModalClosed);
                }}
            >
                <StyledH2 className="text-uppercase mdi_txt_AFlistOfInformationModes">
                    {t("List of mode of information")}
                </StyledH2>
            </ModalHeader>
            <ModalBody>
                <DynamicTable
                    url={url}
                    requestHeader={{
                        "Accept-Language": i18nextLng,
                        ...getAuthHeader,
                    }}
                    canSelect
                    customSelect
                    canMovedCheckboxLeftOnExpand
                    setSelectedRows={setSelectedRows}
                    canResize
                    actionColumn={ActionColumn}
                    arrayOfCustomColumns={arrayOfCustomColumns}
                    showGlobalFilter
                    setDataIsUpdated={setDataIsUpdated}
                    dataIsUpdated={dataIsUpdated}
                    elevationTable={1}
                    minHeight="500px"
                    maxHeight="500px"
                    name="associateModeOfInformation"
                />
            </ModalBody>
            <ModalFooter className="border-top-0">
                <CustomSecondaryColorButton
                    outline
                    className="mdi_btn_AFcancel"
                    variant="light"
                    onClick={() => {
                        setIsAssociateModalOpened(!isAssociateModalOpened);
                        setIsAssociateModalClosed(!isAssociateModalClosed);
                    }}
                    rounded
                >
                    {t("Cancel")}
                </CustomSecondaryColorButton>
                <CustomMainColorButton
                    rounded
                    className="mdi_btn_AFvalidate"
                    variant="primary"
                    onClick={handleValidateClick}
                >
                    {t("Validate")}
                </CustomMainColorButton>
            </ModalFooter>
        </StyledModal>
    );
}
